module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"placeholder":"{0} 輸入"}}')
  delete Component.options._Ctor
}
